<template>
<b-container>
    <div class="body-wrapper">
        <div class="body-title">
          <b-row>
            <b-col>
              <h5 style="color:#2284ab">Payments List</h5>
            </b-col>
          </b-row>
        </div>
        <div class="body-content">
            <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
            <b-alert :show = "showDismissibleAlert" dismissible 
                @dismissed="showDismissibleAlert=false"
                :variant="variant">
                {{alertText}}
            </b-alert>
            <b-row class="mb-2">
                <b-col md="4" >
                    
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" size="sm" />
                        <b-input-group-append>
                        <b-btn :disabled="!filter" @click="filter = ''"  size="sm">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    
                </b-col>
                <b-col></b-col>
                <b-col md="4" >
                    <b-form-group horizontal label="Sort" class="mb-0" label-size="sm" label-cols="1">
                    <b-input-group>
                        <b-form-select v-model="sortBy" :options="sortOptions"  size="sm">
                        <option slot="first" :value="null">-- none --</option>
                        </b-form-select>
                        <b-input-group-append>
                        <b-form-select :disabled="!sortBy" v-model="sortDesc"  size="sm">
                            <option :value="false">Asc</option>
                            <option :value="true">Desc</option>
                        </b-form-select>
                        </b-input-group-append>
                    </b-input-group>
                    </b-form-group>
                </b-col>
            
            </b-row>

            <!-- test -->

              <!-- Main table element -->
          <b-table show-empty head-variant="dark"
                    empty-text="You have not yet made any payment"
                      stacked="md"
                      bordered
                      striped
                      :items="payments"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      @filtered="onFiltered"
                      style="font-size:12px"
                     
          >
           
            <template slot="actions" slot-scope="row">
                <b-button size="sm" @click.stop="showDetails(row.item, row.index, $event.target)" 
                    class="mr-1 pt-0 pb-0" variant="outline-success" v-b-tooltip.hover title="View Details">
                    Print Receipt
                </b-button>
            </template>
              
          </b-table>
              <b-row>
                  <b-col md="8" class="my-1">
                  <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0"  size="sm"/>
              </b-col>
              <b-col md="4" class="my-1">
                  <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
                  <b-form-select :options="pageOptions" v-model="perPage"  size="sm" />
                  </b-form-group>
              </b-col>
          </b-row>
        </div>
    </div>

</b-container>
</template>

<script>
import apis from "../apis";
import Spinner from "vue-simple-spinner";

const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC"
];


export default {
  components: { Spinner },
  data() {
    return {
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: true,
      isLoading2: false,
      payments: [],
      items:[],
      counter: 0,
      max: 0,
      fields: [
        { key: "UserName", label: "User Name", sortable: true },
        { key: "TransacstionRefNum", label: "TransacstionRefNum", sortable: true },
        { key: "TransactionType", label: "Transaction Type", sortable: true },
        { key: "TransactionAmount", label: "Amount Paid", sortable: true },
        { key: "TransactionDate", label: "Payment Date",formatter: "convertDateFormat",sortable: true },
        { key: "TransactionStatus", label: "Status", sortable: true },
        { key: "actions", label: "Apply" }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedEventId: ""
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  
  methods: {
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },

      convertDateFormat(inDate) {
      //return indate.split("T")[0];
      let dbDateTime = new Date(inDate);
      if(dbDateTime.getFullYear()==1){
        return null;
      }

      let formattedDate =
        dbDateTime.getDate() +
        "-" +
        months[dbDateTime.getMonth()] +
        "-" +
        dbDateTime.getFullYear()+
        "    " +
        dbDateTime.getHours()+
        ":"+
        dbDateTime.getMinutes()+
        ":"+
        dbDateTime.getSeconds();
      
      return formattedDate;
    },
    

    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showDetails(item, index, button) {
      this.$store.dispatch('setPrintPmt', true);
      this.$router.push({path:'PaymentConfirm', query:{'payment_id':item.TransacstionRefNum, payment_request_id:item.SessionToken}})
      
    }
    
  },
  mounted() {
    this.isLoading = true;
    var userinfo = this.$store.getters.loggedUser;
    let promise = apis.getUserPaymentDetails(userinfo.UserId);

    promise
      .then(response => {
        //console.log('Reponse' ,response);
        if (response.status == 200) {
          this.payments = response.body;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
        this.isLoading = false;
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
        this.isLoading = false;
      });
  }
};
</script>

<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-content {
  padding: 25px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentList.vue